module.exports = __webpack_public_path__ + "img/EmergencyRecordingOutlined.fa48081b.svg";